import Tooltip from '@/ui/Tooltip'
import { getLabelStroke } from './renderUtils'
import type { ExtrapolatedGraphAnnotation } from './types'

type AnnotationLabelProps = {
  annotation: ExtrapolatedGraphAnnotation
  backgroundColor: string
  isHighestVisible: boolean
}

export const AnnotationLabel = ({
  annotation,
  backgroundColor,
  isHighestVisible,
}: AnnotationLabelProps) => {
  const annotationLabel = (
    <div
      className="absolute text-[10px] tracking-wide whitespace-nowrap"
      style={{
        left: annotation.x,
        top: annotation.y,
        fontSize: annotation.fontSize ?? 10,
        transform: annotation.transform,
        zIndex: 20,
        color: annotation.color,
        opacity: annotation.opacity === 0 ? 0 : undefined,
        pointerEvents: annotation.pointerEvents ?? (
          (annotation.opacity ?? 1) > 0 ? 'auto' : 'none'
        ),
        touchAction: 'pan-y',
        filter: annotation.saturation !== undefined
          ? `saturate(${annotation.saturation})`
          : undefined,
        ...(annotation.flatBackground
          ? {
            backgroundColor: annotation.textShadowColor ?? backgroundColor,
            padding: '0 3px',
            height: annotation.height,
            lineHeight: annotation.height != null
              ? `${annotation.height}px`
              : undefined,
          }
          : {
            textShadow: getLabelStroke(
              annotation.textShadowColor ?? backgroundColor
            ),
          }),
        transition: annotation.transitionDurationMs
          ? `opacity ${annotation.transitionDurationMs}ms`
          : undefined,
      }}
    >
      <span className="font-bold">{annotation.text}</span>
      {isHighestVisible && annotation.subtitle && (
        <div className=" text-center" style={{ fontSize: 9 }}>
          {annotation.subtitle}
        </div>
      )}
    </div>
  )
  if (!annotation.tooltip) return (
    <div key={annotation.key}>
      {annotationLabel}
    </div>
  )
  return (
    <Tooltip
      key={annotation.key}
      content={
        <div className="flex flex-col">
          {Array.isArray(annotation.tooltip)
            ? annotation.tooltip.map((line, i) => <div key={i}>{line}</div>)
            : annotation.tooltip}
        </div>
      }
      placement="top-start"
    >
      {annotationLabel}
    </Tooltip>
  )
}
